<template>
  <div class="content_two">
    <div class="set_bgc">
      <div class="close" @click="gohome">
        <img src="../assets/images/close.png" alt />
      </div>
      <div class="header_box">
        <!--  -->
        <div class="header">
          <img :src="info.headimgurl" class="header_img" alt />
        </div>
        <img src="../assets/images/upload.png" alt @click="show_shade=true" class="upload" />
      </div>
      <div class="user">
        <input type="text" v-model="name" class="register_name" />
        <span class="register_name_label label">姓名:</span>
        <input type="text" v-model="school" class="register_school" />
        <!-- <select name="register_school" id="" class="register_school" v-model="school_val">
                    <option v-for="item in school" :key="item.id" :value="item.id">{{item.school_name}}</option>
        </select>-->
        <span class="register_school_label label">学校:</span>

        <select name="register_grade" id class="register_grade" v-model="grade_val">
          <option v-for="item in grade" :key="item.id" :value="item.id">{{item.grade_name}}</option>
        </select>
        <span class="register_grade_label label">班级:</span>

        <!-- <input type="text" v-model="gender" class="register_gender"> -->
        <select name="register_gender" id class="register_gender" v-model="gender">
          <option value="1">男</option>
          <option value="0">女</option>
        </select>
        <span class="register_gender_label label">性别:</span>

        <input type="text" class="register_birthday" />
        <el-date-picker
          v-model="birthday"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
        <span class="register_birthday_label label">生日:</span>
      </div>
      <img src="../assets/images/out_login.png" class="out_login" alt @click="out_login" />
      <img src="../assets/images/tijiao.png" class="submit_login" alt @click="editIfo" />
    </div>
    <div class="shade" v-if="show_shade">
      <div class="header_list">
        <ul>
          <li v-for="(item,index) in headers" :key="index">
            <div class="system_box">
              <img
                :src="item.img_url"
                alt
                class="system_header"
                @click="select_header(index,item.img_path)"
                :class="{'select_show' :show_select==index}"
              />
              <img
                src="../assets/images/select_header.png"
                alt
                class="selecet_header"
                v-if="show_select==index"
              />
            </div>
          </li>
        </ul>
        <img src="../assets/images/queding.png" class="queding" alt @click="change_header" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "set",
  data() {
    return {
      name: "",
      school_val: "",
      school: "",
      grade_val: "",
      gender: "",
      birthday: "",
      //学校列表
      // school:[],
      //班级列表
      grade: [],
      show_select: null,
      show_shade: false,
      info: "",
      headers: [],
      //头像
      headerurl: ""
    };
  },
  created() {
    // this.getschool();
    this.getgrade();
    this.getinfo();
    this.getheader();
  },
  methods: {
    //获取学校，班级下拉数据
    // getschool(){
    //   this.$axios.get(
    //     '/api/v1/getschools',
    //   ).then(res=>{
    //     this.school=res.data.data
    //   })
    // },
    getgrade() {
      this.$axios.get("/api/v1/getgrades").then(res => {
        this.grade = res.data.data;
      });
    },
    gohome() {
      this.$router.replace("/newHome");
    },
    select_header(num, url) {
      if (this.show_select == num) return;
      this.show_select = num;
      this.headerurl = url;
    },
    //获取个人信息
    getinfo() {
      this.$axios.get("/api/v1/user/info").then(res => {
        // console.log(res);
        // if(res.data.data.sex==1){
        //     res.data.data.sex='男'
        // }else{
        //     res.data.data.sex='女'
        // }
        this.info = res.data.data;
        this.name = res.data.data.username;
        this.gender = res.data.data.sex;
        this.birthday = res.data.data.birthday;
        this.school = res.data.data.school_id;
        this.grade_val = res.data.data.grade_id;
      });
    },
    //获取系统头像
    getheader() {
      this.$axios.get("/api/v1/getheadimg").then(res => {
        // console.log(res);
        this.headers = res.data.data;
      });
    },
    //更换头像
    change_header() {
      this.$axios
        .post("/api/v1/user/editinfo", {
          headimgurl: this.headerurl
        })
        .then(res => {
          // console.log(res);
          if (res.data.result_code == 200) {
            this.$msg.success(res.data.message);
            this.show_shade = false;
            this.getinfo();
          } else {
            this.$msg.error(res.data.message);
          }
        });
    },
    //修改个人信息
    editIfo() {
      // 10
      // if(this.gender=='男'){
      //     this.gender=1
      // }else {
      //     this.gender=0
      // }
      this.$axios
        .post("/api/v1/user/editinfo", {
          username: this.name,
          sex: this.gender,
          birthday: this.birthday,
          school: this.school,
          grade: this.grade_val
        })
        .then(res => {
          if (res.data.result_code == 200) {
            this.$msg.success(res.data.message);
            this.getinfo();
          } else {
            this.$msg.error(res.data.message);
          }
        });
    },
    //退出登录
    out_login() {
      window.sessionStorage.removeItem("token");
      this.$msg.success("退出成功");
      setTimeout(() => {
        this.$router.replace("/login");
      }, 2000);
    }
  },
  mounted() {}
};
</script>
<style scoped>
::-webkit-scrollbar {
  width: 0.133333rem;
  height: 0.09rem;
}
.set_bgc {
  width: 5.01rem;
  height: 4.3rem;
  background: url("../assets/images/set_bgc.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.close {
  width: 0.65rem;
  height: 0.65rem;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.close img {
  width: 100%;
  height: 100%;
}
.out_login {
  width: 1.36rem;
  height: 0.41rem;
  position: absolute;
  bottom: 0rem;
  left: 20%;
  /* transform: translate(-25%,0); */
}
.submit_login {
  width: 1.36rem;
  height: 0.41rem;
  position: absolute;
  bottom: 0rem;
  right: 20%;
  /* transform: translate(-25%,0); */
}
.header_box {
  width: 0.82rem;
  height: 0.82rem;
  position: absolute;
  top: 0.55rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.header_box .header {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/images/header_bgc.png") no-repeat;
  background-size: 100% 100%;
}
.header_img {
  width: 0.74rem;
  height: 0.74rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.upload {
  width: 0.33rem;
  height: 0.33rem;
  position: relative;
  bottom: 0.3rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.user {
  width: 80%;
  position: absolute;
  top: 1.4rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 0.21rem;
  font-family: "Normal";
  color: #242424;
  font-weight: 500;
  /* text-align: center; */
}
.user .name {
  text-align: center;
}
.school_grade {
  margin-top: 0.1rem;
  font-size: 0.22rem;
  font-family: "Normal";
  font-weight: 500;
  color: #242424;
}
.school_grade span {
  color: #914b07;
}
input {
  width: 2.96rem;
  height: 0.4rem;
  background-color: #914b07;
  border-radius: 0.2rem;
  border: none !important;
  font-size: 0.17rem;
  font-family: "Normal";
  color: #fff;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
input:focus-visible {
  outline: none;
}
.modile {
  position: absolute;
  top: 2.4rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.modile_lable {
  position: absolute;
  top: 2.485rem;
  right: 1.23rem;
}
.pswd {
  position: absolute;
  top: 2.9rem;
  left: 50%;
  transform: translate(-50%, 0);
}
.pswd_lable {
  position: absolute;
  top: 2.985rem;
  right: 1.23rem;
}
.lable {
  display: inline-block;
  width: 0.65rem;
  height: 0.23rem;
  z-index: 2;
  background-color: #69a0ca;
  text-align: center;
  line-height: 0.23rem;
  color: #fff;
  border-radius: 0.05rem;
}
.shade {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}
.header_list {
  width: 100%;
  height: 1.46rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  padding: 0.33rem 0.59rem 0.23rem 0.63rem;
}
ul {
  width: auto;
  height: 126%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
ul li {
  display: inline-block;
}
.system_box {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 0.05rem;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 0.23rem;
}
.system_header {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 0.05rem;
  box-sizing: border-box;
  border: 0.03rem solid transparent;
}
.select_show {
  border: 0.03rem solid #ffe400;
}
.selecet_header {
  width: 0.23rem;
  height: 0.23rem;
  position: absolute;
  bottom: 0;
  right: 0;
}
.queding {
  width: 0.72rem;
  height: 0.24rem;
  position: absolute;
  bottom: -0.4rem;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
}
.label {
  font-size: 0.17rem;
  font-family: "Normal";
  color: #ffffff;
  z-index: 2;
  height: 0.4rem;
  line-height: 0.4rem;
}
.register_name_label {
  position: absolute;
  top: 0rem;
  left: 0.7rem;
}
.register_school_label {
  position: absolute;
  top: 0.5rem;
  left: 0.7rem;
}
.register_name {
  position: absolute;
  top: 0rem;
  left: 50%;
  transform: translate(-50%, 0);
  box-sizing: border-box;
  padding-left: 0.7rem;
}
.register_school {
  position: absolute;
  top: 0.5rem;
  left: 50%;
  transform: translate(-50%, 0);
  box-sizing: border-box;
  padding-left: 0.7rem;
}
.register_grade_label {
  position: absolute;
  top: 1rem;
  left: 0.7rem;
}
.register_grade {
  position: absolute;
  top: 1rem;
  left: 50%;
  transform: translate(-50%, 0);
  box-sizing: border-box;
  padding-left: 0.7rem;
}
.register_gender_label {
  position: absolute;
  top: 1.5rem;
  left: 0.7rem;
}
.register_gender {
  position: absolute;
  top: 1.5rem;
  left: 50%;
  transform: translate(-50%, 0);
  box-sizing: border-box;
  padding-left: 0.7rem;
}
.register_birthday_label {
  position: absolute;
  top: 2rem;
  left: 0.7rem;
}
.register_birthday {
  position: absolute;
  top: 2rem;
  left: 50%;
  transform: translate(-50%, 0);
  box-sizing: border-box;
  padding-left: 0.7rem;
}
select {
  width: 2.91rem;
  height: 0.4rem;
  background-color: #914b07;
  border-radius: 0.2rem;
  border: none !important;
  font-size: 0.17rem;
  font-family: "Normal";
  color: #fff;
  box-sizing: border-box;
  padding-left: 0.86rem;
  appearance: none;
}
select:focus-visible {
  outline: none;
}
::v-deep .el-date-editor.el-input,
::v-deep .el-date-editor.el-input__inner {
  position: absolute;
  top: 2rem;
  left: 1.1rem;
  width: 2.1rem;
}
::v-deep .el-input__inner {
  background-color: #914b07;
  border: none;
  color: #fff;
  font-size: 0.16rem;
  font-family: "Normal";
  height: 0.4rem;
  border-radius: 0.2rem;
  line-height: 0.4rem;
}
::v-deep .el-input__icon {
  line-height: 0.4rem;
}
</style>
